import React, { useEffect, useState } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';//NEW
import { useLocation, useNavigate } from 'react-router-dom';
import useMediaQuery from '../../hooks/useMediaQuery';
import useClassi from '../../hooks/useClassi';
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow';
import { Button, Card, Row, Col, Badge, Accordion, ListGroup, Form, Spinner } from 'react-bootstrap';
import UtilityService from '../../services/UtillityServices/UtilityService';
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import useContenutiUtenti from '../../hooks/useContenutiUtenti';
import { alertService } from '../../services/AlertService';
import useWebSocket from '../../hooks/useWebSocket';
import ProtectedContent from '../../components/ProtectedContent/ProtectedContent';
import useAttestati from '../../hooks/useAttestati';

const AreaPersonaleClassePage = () => {
  const navigate = useNavigate();
  const { loadingStateClassi, getMaterialiClasse } = useClassi();
  const { downloadAttestato, loadingStateAttestati } = useAttestati();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(max-width: 991px)');
  const { classe } = useLocation().state || {};
  const [materialiData, setMaterialiData] = useState(null);
  const { iniziaContenuto, getUrl } = useContenutiUtenti();
  const [loadingContentId, setLoadingContentId] = useState(null);
  const { checkContentStatus, isConnected } = useWebSocket();
  const [selectedContent, setSelectedContent] = useState(null);
  const [attestatoType, setAttestatoType] = useState('verticale');
  const [fingerprint, setFingerprint] = useState('');//NEW


  const getAllAreaIds = (areas) => {
    let ids = areas.map(area => String(area.id));
    areas.forEach(area => {
      if (area.sottoaree.length > 0) {
        ids = [...ids, ...getAllAreaIds(area.sottoaree)];
      }
    });
    return ids;
  };

  useEffect(() => {
    if(!classe) {
      navigate("/area-personale/corsi");
      return;
    }
    fetchClassi();
  }, [classe]);

  useEffect(() => {
    if (isConnected && classe) {
      checkContentStatus(classe);
      
      const interval = setInterval(() => {
        checkContentStatus(classe.id_classe);
      }, 60000);

      const handleStatusUpdate = (event) => {
        const { contenuti } = event.detail;
        setMaterialiData(prevData => ({
          ...prevData,
          contenuti: contenuti
            .map(newContenuto => ({
              ...prevData.contenuti.find(c => c.id_contenuto === newContenuto.id_contenuto),
              ...newContenuto,
              opzionale: prevData.contenuti.find(c => c.id_contenuto === newContenuto.id_contenuto)?.opzionale ?? 1
            }))
            .sort((a, b) => a.id_contenuto - b.id_contenuto)
        }));
      };

      window.addEventListener('contenutiStatusUpdate', handleStatusUpdate);

      return () => {
        clearInterval(interval);
        window.removeEventListener('contenutiStatusUpdate', handleStatusUpdate);
      };
    } else {
      console.log('WebSocket: Non connesso');
    }
  }, [isConnected, classe, checkContentStatus]);

  useEffect(() => {
    // Funzione asincrona per caricare FingerprintJS
    const getFingerprint = async () => {
      // Carica l'agente
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      // Prende l'ID del visitatore
      setFingerprint(result.visitorId);
    };
    getFingerprint();
  }, []);

  //console.log('Fingerprint:', fingerprint);//TODO iniziaContenuto

  const fetchClassi = async () => {
    fetchMateriali();
  }

  const renderAttestatoSection = () => {
    if (!materialiData?.attestato_disponibile) return null;

    return (
      <Card className="border-0 shadow-sm mb-4" style={{ backgroundColor: '#f8f9fa' }}>
        <Card.Body className="p-4">
          <div className={`d-flex ${isTablet ? 'flex-column' : 'justify-content-between'} align-items-${isTablet ? 'start' : 'center'}`}>
            <div className={`d-flex align-items-center ${isTablet ? 'mb-4' : ''}`}>
              <div className="me-4">
                <i className="bi bi-trophy-fill text-warning" style={{ fontSize: isMobile ? '2.5rem' : '3rem' }}></i>
              </div>
              <div>
                <h4 className={`mb-2 ${isMobile ? 'fs-5' : ''}`}>Congratulazioni!</h4>
                <p className={`mb-0 text-muted ${isMobile ? 'small' : ''}`}>
                  Hai completato il corso con successo. Puoi scaricare il tuo attestato.
                </p>
              </div>
            </div>
            <div className={`d-flex align-items-center ${isMobile ? 'flex-column w-100' : ''}`}>
              <Form.Select 
                size={isMobile ? "sm" : ""}
                value={attestatoType}
                onChange={(e) => setAttestatoType(e.target.value)}
                className={`${isMobile ? 'w-100 mb-3' : 'me-3'}`}
                style={{ width: isMobile ? '100%' : 'auto' }}
              >
                <option value="verticale">Formato Verticale</option>
                <option value="orizzontale">Formato Orizzontale</option>
              </Form.Select>
              <Button 
                variant="primary"
                onClick={() => handleDownloadAttestato()}
                disabled={loadingStateAttestati.isLoadingDownloadAttestato}
                className={isMobile ? 'w-100' : ''}
              >
                {loadingStateAttestati.isLoadingDownloadAttestato ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Scaricamento...
                  </>
                ) : (
                  <>
                    <i className="bi bi-download me-2"></i>
                    Scarica Attestato
                  </>
                )}
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  };

  const handleDownloadAttestato = async () => {
    await downloadAttestato({ 
      id_classe_utente: classe.id_classe_utente, 
      tipo_attestato: attestatoType 
    });
  };

  const fetchMateriali = async () => {
    const response = await getMaterialiClasse({ id_classe: classe.id_classe, id_classe_utente: classe.id_classe_utente });
    setMaterialiData(response);
  }

  const getNextLesson = (lezioni) => {
    if (!lezioni || lezioni.length === 0) return null;
    
    const today = new Date();
    const futureLezioni = lezioni
      .filter(lezione => new Date(lezione.data) >= today)
      .sort((a, b) => new Date(a.data) - new Date(b.data));
    
    return futureLezioni[0];
  };

  const renderArea = (area, level = 0) => {
    return (
      <Accordion.Item 
        key={area.id} 
        eventKey={String(area.id)}
        className={`border-0 opacity-level-${level}`}
      >
        <Accordion.Header>
          <div 
            className="d-flex align-items-center w-100" 
            style={{
              paddingLeft: level > 0 ? `${level * 2.5}rem` : '0',
              position: 'relative'
            }}
          >
            <div className="d-flex align-items-center p-2 rounded-2 flex-grow-1 shadow-sm">
              <i className="bi bi-folder2 text-warning fs-4 me-3"></i>
              <div>
                <h5 className="mb-0 text-white">{area.titolo}</h5>
                <small className="text-light mt-1 d-block">
                  {area.contenuti.length} contenut{area.contenuti.length === 1 ? 'o' : 'i'}
                </small>
              </div>
            </div>
          </div>
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <ListGroup className="position-relative">
            <div 
              className="position-absolute" 
              style={{
                left: `${level * 2.5 + 1}rem`,
                top: 0,
                bottom: 0,
                width: '2px',
                backgroundColor: '#dee2e6'
              }}
            />
            
            {area.contenuti.map((contenuto, contentIndex) => {
              const isBlocked = contenuto.id_contenuto_propedeutico ? 
                               !materialiData.contenuti.find(
                                 c => c.id_contenuto === contenuto.id_contenuto_propedeutico
                               )?.completato : false;
              return (
                <ListGroup.Item 
                  key={contenuto.id_contenuto}
                  className={`py-3 ${!isBlocked ? 'cursor-pointer hover-light' : ''}`}
                  disabled={isBlocked}
                  style={{
                    position: 'relative',
                    paddingLeft: `${level * 2.5 + 3}rem`,
                    borderBottom: '1px solid rgba(222, 226, 230, 0.8)'
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div className="me-3 d-flex align-items-center justify-content-center" 
                         style={{
                           width: '40px',
                           height: '40px',
                           borderRadius: '8px',
                           background: isBlocked ? '#f8f9fa' : 'rgba(253, 126, 20, 0.1)'
                         }}>
                      {isBlocked ? (
                        <i className="bi bi-lock-fill text-secondary fs-4"></i>
                      ) : (
                        <i className={`bi ${
                          contenuto.tipo_contenuto === 'pdf' ? 'bi-file-pdf text-danger' : 
                          contenuto.tipo_contenuto === 'audio-video' ? 'bi-play-circle-fill text-primary' : 
                          contenuto.tipo_contenuto === 'documento-testo' ? 'bi-file-text text-success' : 
                          contenuto.tipo_contenuto === 'test' ? 'bi-pencil-square text-success' : 
                          'bi-file-text text-info'} fs-4`}></i>
                      )}
                    </div>
                    
                    <div className="flex-grow-1">
                      <h6 className="mb-1">
                        {contentIndex + 1}. {contenuto.titolo}
                      </h6>
                      {isBlocked && contenuto.id_contenuto_propedeutico && (
                        <div className="mt-1">
                          <small className="text-dark">
                            <i className="bi bi-info-circle me-1 text-primary"></i>
                            Per sbloccare questo contenuto devi prima visualizzare:
                            <strong className="ms-1 text-primary">
                              {materialiData.contenuti.find(c => 
                                c.id_contenuto === contenuto.id_contenuto_propedeutico
                              )?.titolo}
                            </strong>
                            <span><i> e attendere il relativo <b>vincolo temporale</b> indicato</i></span>
                          </small>
                        </div>
                      )}
                      {contenuto.tipo_contenuto === 'test' && contenuto.completato && (
                        <small className="text-success d-block">
                          <i className="bi bi-check-circle-fill me-1"></i>
                          Test completato
                        </small>
                      )}
                      {contenuto.tipo_contenuto !== 'test' && contenuto.completato && (
                        <small className="text-success d-block">
                          <i className="bi bi-check-circle-fill me-1"></i>
                          Contenuto visualizzato
                        </small>
                      )}
                    </div>

                    {!isBlocked && (
                      <Button 
                        variant="warning"
                        onClick={() => handleContenutoClick(contenuto)}
                        size="sm" 
                        className="rounded-circle"
                        style={{ width: '32px', height: '32px'}}
                      >
                        {loadingContentId === contenuto.id_contenuto ? (
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Caricamento...</span>
                          </div>
                        ) : (
                          <i className="bi bi-play-fill"></i>
                        )}
                      </Button>
                    )}
                  </div>
                </ListGroup.Item>
              );
            })}
          </ListGroup>
          {area.sottoaree.length > 0 && (
            <Accordion defaultActiveKey={getAllAreaIds(area.sottoaree)} className="border-0" alwaysOpen>
              {area.sottoaree.map(sottoarea => renderArea(sottoarea, level + 1))}
            </Accordion>
          )}
        </Accordion.Body>
      </Accordion.Item>
    );
  };

  const organizeContentByArea = (contenuti) => {
    if (!contenuti) return [];
    
    const sortedContents = [...contenuti].sort((a, b) => a.id_contenuto - b.id_contenuto);
    
    const areeMap = new Map();
    
    sortedContents.forEach(contenuto => {
      if (!areeMap.has(contenuto.id_area)) {
        areeMap.set(contenuto.id_area, {
          id: contenuto.id_area,
          titolo: contenuto.titolo_area,
          id_area_padre: contenuto.id_area_padre,
          contenuti: [],
          sottoaree: []
        });
      }
    });
    
    const areeRadice = [];
    areeMap.forEach(area => {
      if (area.id_area_padre === 0) {
        areeRadice.push(area);
      } else {
        const areaPadre = areeMap.get(area.id_area_padre);
        if (areaPadre) {
          areaPadre.sottoaree.push(area);
        }
      }
    });
    
    sortedContents.forEach(contenuto => {
      const area = areeMap.get(contenuto.id_area);
      if (area) {
        area.contenuti.push(contenuto);
      }
    });

    return (
      <Accordion defaultActiveKey={getAllAreaIds(areeRadice)} alwaysOpen>
        {areeRadice.map(area => renderArea(area))}
      </Accordion>
    );
  };

  const calculateProgress = (lezioni, contenuti) => {
    if (!lezioni?.length && !contenuti?.length) return 0;
    
    const today = new Date();
    const totalLezioni = lezioni?.length || 0;
    const lezioniPassate = lezioni?.filter(lezione => new Date(lezione.data) < today).length || 0;
    
    const contenutiObbligatori = contenuti?.filter(contenuto => contenuto.opzionale === 0) || [];
    const totalContenutiObbligatori = contenutiObbligatori.length;
    const contenutiCompletati = contenutiObbligatori.filter(contenuto => contenuto.completato).length;
    
    const totalItems = totalLezioni + totalContenutiObbligatori;
    if (totalItems === 0) return 0;
    
    const progressoTotale = lezioniPassate + contenutiCompletati;
    return Math.round((progressoTotale / totalItems) * 100);
  };

  const handleContenutoClick = async (contenuto) => {
    try {
      setLoadingContentId(contenuto.id_contenuto);
      
      await iniziaContenuto({
        id_contenuto: contenuto.id_contenuto,
        id_classe: classe.id_classe,
        fngr_prnt: fingerprint
      });

      if (contenuto.tipo_contenuto === 'test') {
        navigate('/test-survey', { 
          state: { 
            classeData: classe,
            selectedContenuto: contenuto
          }
        });
        return;
      }

      const urlResponse = await getUrl({ 
        id_contenuto: contenuto.id_contenuto,
        id_classe: classe.id_classe 
      });

      setSelectedContent({
        url_contenuto: urlResponse.url,
        tipo_contenuto: contenuto.tipo_contenuto,
        titolo: contenuto.titolo,
        formato_contenuto: contenuto.formato_contenuto,
        contenuto: contenuto.contenuto,
        id_contenuto: contenuto.id_contenuto
      });
    } catch (error) {
      alertService.error('Errore durante l\'apertura del contenuto', { autoClose: true });
    } finally {
      setLoadingContentId(null);
    }
  };

  const nextLesson = getNextLesson(materialiData?.lezioni);
/*   const progress = calculateProgress(materialiData?.lezioni, materialiData?.contenuti); */

  if(loadingStateClassi.isLoadingMaterialiClasse) {
    return <CardLoadingPage />;
  }

  return (
    <>
      <div className="card custom-card w-100 shadow">
        <div className={`${isMobile ? 'p-3' : 'p-5'}`}>
          <div className='container'>
            <div className='mb-4'>
              <ComebackArrow path={"/area-personale/corsi"} />
            </div>

            {/* Hero Section con immagine */}
            <Card className='border-0 shadow-sm w-100 position-relative overflow-hidden mb-4'>
              <div 
                className="position-absolute w-100 h-100" 
                style={{
                  backgroundImage: `url("${classe?.corso?.immagine_corso || 'default-course-image.jpg'}")`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
              <div 
                className="position-absolute w-100 h-100" 
                style={{
                  background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.7) 100%)',
                }}
              />
              <Card.Body 
                className="position-relative text-white" 
                style={{ 
                  minHeight: '400px',
                  paddingTop: '3rem',
                  paddingBottom: isMobile ? '10rem' : '8rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem'
                }}
              >
                <div className="d-flex flex-column h-100">
                  <div>
                    <h2 className={`${isMobile ? 'h3' : 'display-4'} fw-bold mb-3`}>
                      {materialiData?.denominazione_corso}
                    </h2>
                    <div className='d-flex align-items-center text-white'>
                      <i className='bi bi-calendar3 fs-4 me-2'></i>
                      <span className={`${isMobile ? 'small' : 'fs-5'}`}>
                        {UtilityService.formatDate(materialiData?.data_inizio)} - {UtilityService.formatDate(materialiData?.data_fine)}
                      </span>
                    </div>
                  </div>
                </div>
              </Card.Body>
              
              <div 
                className="position-absolute start-0"
                style={{ bottom: '2.5rem' }}
              >
                <div className={`d-flex ${isMobile ? 'flex-column' : ''} gap-3 px-4`}>
                  <Button 
                    variant="outline-light" 
                    className={`d-flex align-items-center gap-2 px-4 py-2 ${isMobile ? 'w-100' : ''}`}
                    onClick={() => navigate(`/area-personale/calendario/lezioni`, {
                      state: { classeData: classe }
                    })}
                  >
                    <i className='bi bi-calendar-event'></i>
                    Calendario Lezioni
                  </Button>
                  <Button 
                    variant="outline-light"
                    className={`d-flex align-items-center gap-2 px-4 py-2 ${isMobile ? 'w-100' : ''}`}
                    onClick={() => navigate(`/area-personale/calendario/esami`, {
                      state: { classeData: classe }
                    })}
                  >
                    <i className='bi bi-calendar-check'></i>
                    Calendario Esami
                  </Button>
                </div>
              </div>
            </Card>

            {/* Attestato Section */}
            {renderAttestatoSection()}

            {/* Info Cards Row */}
            <Row className='g-4 mb-4'>
              <Col xs={12}>
                <Card className='border-0 shadow-sm h-100' style={{ backgroundColor: '#f8f9fa' }}>
                  <Card.Body className="p-4">
                    <div className="d-flex flex-column h-100">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className='mb-0 d-flex align-items-center text-primary'>
                          <i className='bi bi-camera-video-fill me-2'></i>
                          Prossima Lezione
                        </h4>
                        {nextLesson && (
                          <Button 
                            variant='primary'
                            onClick={() => {
                              alertService.warn("Integrazione con Jampkin", { autoClose: true });
                            }}
                          >
                            <i className='bi bi-box-arrow-up-right me-2'></i>
                            Accedi alla lezione
                          </Button>
                        )}
                      </div>
                      {nextLesson ? (
                        <div>
                          <h5 className="mb-3">{nextLesson.titolo}</h5>
                          <p className='text-muted mb-0'>
                            <i className='bi bi-calendar-event me-2'></i>
                            {UtilityService.formatDate(nextLesson.data)}
                            <br />
                            <i className='bi bi-clock me-2'></i>
                            {nextLesson.ora_inizio.slice(0, 5)} - {nextLesson.ora_fine.slice(0, 5)}
                          </p>
                        </div>
                      ) : (
                        <p className="text-muted">Nessuna lezione programmata</p>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>

     {/*          <Col xs={12} md={6}>
                <Card className='border-0 shadow-sm h-100' style={{ backgroundColor: '#f8f9fa' }}>
                  <Card.Body className="p-4 d-flex flex-column justify-content-center">
                    <h4 className='mb-4 d-flex align-items-center text-success'>
                      <i className='bi bi-graph-up me-2'></i>
                      Progresso del corso
                    </h4>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <div className="progress" style={{ height: '8px', backgroundColor: '#e9ecef' }}>
                          <div 
                            className="progress-bar bg-success" 
                            role="progressbar" 
                            style={{ width: `${progress}%` }} 
                            aria-valuenow={progress} 
                            aria-valuemin="0" 
                            aria-valuemax="100"
                          />
                        </div>
                      </div>
                      <span className="ms-3 fw-bold text-success">{progress}%</span>
                    </div>
                  </Card.Body>
                </Card>
              </Col> */}
            </Row>

            {/* Contenuti Section */}
            <Card className='border-0 shadow-sm' style={{ backgroundColor: '#f8f9fa' }}>
              <Card.Body className="p-4">
                <div className={`d-flex justify-content-between align-items-center mb-4 ${isMobile ? 'flex-column' : ''}`}>
                  <div>
                    <h4 className='mb-2'>
                      <i className='bi bi-collection-play text-primary me-2'></i>
                      Contenuti del Corso
                    </h4>
                    <p className="text-muted mb-0">
                      Accedi ai materiali didattici organizzati per area tematica
                    </p>
                  </div>
                  <Badge bg="primary" pill className={`px-3 py-2 ${isMobile ? 'mt-3' : ''}`}>
                    {materialiData?.contenuti?.length || 0} contenuti disponibili
                  </Badge>
                </div>

                {organizeContentByArea(materialiData?.contenuti)}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>

      {/* Modal per i contenuti protetti */}
      <ProtectedContent
        show={!!selectedContent}
        onHide={() => setSelectedContent(null)}
        selectedContenuto={selectedContent}
      />
    </>
  );
};

export default AreaPersonaleClassePage;
